import styled from "styled-components"
import { Button } from "../Button"
import { Select as SelectBase } from "../Select"

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
  gap: 0.5em;
`
export const FilterBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 10px 0;
  position: sticky;
  z-index: 2;
  align-items: stretch;
  justify-content: ${({ hasActiveFilter }) =>
    hasActiveFilter ? "flex-start" : "center"};
  top: ${({ Shrunked }) => (Shrunked ? "160px" : "260px")};
  ${({ Shrunked }) =>
    Shrunked
      ? "box-shadow: 0px 16px 14px -1px rgba(0,0,0,0.10);"
      : "max-width:85em;margin:auto;padding-bottom:1.5em;border-top: 1px solid #d8d8d8;"};

  width: 100%;

  &.mobile {
    top: ${({ Shrunked }) => (Shrunked ? "30px" : "75px")};
  }
`

export const Select = styled(SelectBase)`
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
  max-width: 9em;
  width: 100%;
  text-align: center;
  border: none;
  text-transform: capitalize;

  &.mobile {
    background-color: ${({ theme }) => theme.palette.primary.light};
    font-size: 80%;
  }
  &:focus-visible {
    outline: none;
  }
  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
    outline: none;
  }
  option:hover {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`

export const ResetButton = styled(Button)`
  width: auto;
  margin: 0.3em 0.3em 0.3em 1em;
  background-color: ${({ theme }) => theme.palette.primary.main};
  border: ${({ theme }) => theme.palette.primary.light};
  font-family: ${({ theme }) => theme.typography.body.fontFamily};
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 100%;
  &.mobile {
    height: 100%;
    margin: 0.6em 0.6em 0.4em 0.6em;
    padding: 0.3em;
    font-size: 0.8em;
    grid-area: 4 / 1 / 4 / 4;
  }
`
export const SelectStyled = styled.select`
  width: 100%;
  height: 35px;
  background: white;
  color: gray;
  padding-left: 5px;
  font-size: 14px;
  border: none;
  margin-left: 10px;

  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`

export const Item = styled.div`
  margin-right: 10px;
  padding: 3px 10px;
  border: 1px solid #d1d1d1;
  border-radius: 60px;
  display: flex;
  align-items: center;
  gap: 5px;
  font: normal normal medium 12px Poppins;
`
export const Title = styled.div`
  margin: 1.5em 0 0.5em 0;
  align-items: center;
  font: normal normal 600 26px/17px Cormorant Garamond;
  letter-spacing: -0.65px;
  color: #2b3944;
`
export const WrapperActiveFilter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 5px;
`
